/* NiZED hero: the original NM SVG turbulence, scoped to the visible hero filter. */
(function () {
  'use strict';

  if (window.NiZEDHeroDistortion) {
    window.NiZEDHeroDistortion.init();
    return;
  }

  var controllers = new WeakMap();
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function createController(hero) {
    var turbulence = hero.querySelector('[data-nz-hero-turbulence]');
    var displacement = hero.querySelector('[data-nz-hero-displacement]');
    if (!turbulence || !displacement) return null;

    var frameId = 0;
    var phase = 0;
    var previousTime = 0;
    var visible = true;
    var destroyed = false;
    var observer = null;

    function resetToNmBase() {
      turbulence.setAttribute('baseFrequency', '0.012 0.008');
      displacement.setAttribute('scale', '18');
    }

    function stop() {
      if (frameId) cancelAnimationFrame(frameId);
      frameId = 0;
    }

    function animate(now) {
      if (!frameId || destroyed) return;
      if (!previousTime) previousTime = now;
      var elapsedFrames = Math.min((now - previousTime) / 16.6667, 3);
      phase += 0.004 * elapsedFrames;
      previousTime = now;

      var x = 0.011 + Math.sin(phase) * 0.007;
      var y = 0.007 + Math.cos(phase * 0.7) * 0.005;
      turbulence.setAttribute('baseFrequency', x.toFixed(4) + ' ' + y.toFixed(4));
      frameId = requestAnimationFrame(animate);
    }

    function start() {
      if (frameId || destroyed) return;
      previousTime = 0;
      hero.dataset.nzDistortion = 'nm-svg-running';
      frameId = requestAnimationFrame(animate);
    }

    function update() {
      if (reduceMotion.matches) {
        stop();
        resetToNmBase();
        hero.dataset.nzDistortion = 'static-reduced-motion';
        return;
      }
      if (!visible || document.hidden) {
        stop();
        hero.dataset.nzDistortion = 'paused';
        return;
      }
      start();
    }

    function onVisibilityChange() {
      update();
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        visible = entries[0] ? entries[0].isIntersecting : true;
        update();
      }, { threshold: 0.01 });
      observer.observe(hero);
    }

    document.addEventListener('visibilitychange', onVisibilityChange);
    if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', update);
    update();

    return {
      destroy: function () {
        destroyed = true;
        stop();
        if (observer) observer.disconnect();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        if (reduceMotion.removeEventListener) reduceMotion.removeEventListener('change', update);
      }
    };
  }

  function init(root) {
    (root || document).querySelectorAll('.nz-hero').forEach(function (hero) {
      if (controllers.has(hero)) return;
      var controller = createController(hero);
      if (controller) controllers.set(hero, controller);
    });
  }

  window.NiZEDHeroDistortion = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var hero = event.target && event.target.querySelector ? event.target.querySelector('.nz-hero') : null;
    var controller = hero && controllers.get(hero);
    if (controller) {
      controller.destroy();
      controllers.delete(hero);
    }
  });
})();
